!function (e, t) {
  "object" == typeof exports && "object" == typeof module ? module.exports = t() : "function" == typeof define && define.amd ? define([], t) : "object" == typeof exports ? exports.batmaidTelemetry = t() : e.batmaidTelemetry = t();
}("undefined" != typeof self ? self : this, function () {
  return (() => {
    "use strict";

    var e = {
        d: (t, n) => {
          for (var r in n) e.o(n, r) && !e.o(t, r) && Object.defineProperty(t, r, {
            enumerable: !0,
            get: n[r]
          });
        },
        o: (e, t) => Object.prototype.hasOwnProperty.call(e, t),
        r: e => {
          "undefined" != typeof Symbol && Symbol.toStringTag && Object.defineProperty(e, Symbol.toStringTag, {
            value: "Module"
          }), Object.defineProperty(e, "__esModule", {
            value: !0
          });
        }
      },
      t = {};
    e.r(t), e.d(t, {
      Telemetry: () => d
    });
    var n = "undefined" != typeof window;
    function r(e) {
      return r = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, r(e);
    }
    function o(e, t) {
      for (var n = 0; n < t.length; n++) {
        var o = t[n];
        o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, (void 0, i = function (e, t) {
          if ("object" !== r(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var o = n.call(e, t);
            if ("object" !== r(o)) return o;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        }(o.key, "string"), "symbol" === r(i) ? i : String(i)), o);
      }
      var i;
    }
    var i = function () {
      function e(t) {
        var r = t.domain,
          o = t.language,
          i = t.mobileBreakpoint,
          a = t.platform,
          l = t.context;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.domain = r || n ? window.location.host : "", this.language = o, this.mobileBreakpoint = i || 768, this.platform = a, this.context = l;
      }
      var t, r;
      return t = e, (r = [{
        key: "getStaticProbe",
        value: function () {
          return {
            domain: this.domain,
            featureFlags: this.featureFlags || null,
            language: this.language,
            pageUrl: window.location.href,
            isMobile: this.isMobile(),
            isDesktop: !this.isMobile(),
            pageTitle: document.title,
            platform: this.platform,
            context: this.context
          };
        }
      }, {
        key: "isMobile",
        value: function () {
          return window.innerWidth < this.mobileBreakpoint;
        }
      }]) && o(t.prototype, r), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }();
    function a(e) {
      return a = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, a(e);
    }
    function l(e, t) {
      (null == t || t > e.length) && (t = e.length);
      for (var n = 0, r = new Array(t); n < t; n++) r[n] = e[n];
      return r;
    }
    function u(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, (void 0, o = function (e, t) {
          if ("object" !== a(e) || null === e) return e;
          var n = e[Symbol.toPrimitive];
          if (void 0 !== n) {
            var r = n.call(e, t);
            if ("object" !== a(r)) return r;
            throw new TypeError("@@toPrimitive must return a primitive value.");
          }
          return String(e);
        }(r.key, "string"), "symbol" === a(o) ? o : String(o)), r);
      }
      var o;
    }
    var c = function () {
      function e(t) {
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.endpointUrl = t;
      }
      var t, n;
      return t = e, (n = [{
        key: "sendProbe",
        value: function (e) {
          var t = JSON.stringify({
            features: this.featureFlagsToArray(e.featureFlags),
            event: e.event,
            language: e.language,
            pageUrl: e.pageUrl,
            pageTitle: e.pageTitle,
            buttonLabel: e.buttonLabel,
            buttonId: e.buttonId,
            pageId: e.pageId,
            isMobile: e.isMobile,
            isDesktop: e.isDesktop,
            platform: e.platform,
            domain: e.domain,
            context: e.context || {}
          });
          return "undefined" != typeof navigator && navigator.sendBeacon && navigator.sendBeacon(this.endpointUrl, t) ? Promise.resolve() : fetch(this.endpointUrl, {
            headers: {
              "Content-Type": "application/json"
            },
            method: "POST",
            credentials: "include",
            body: t
          }).then();
        }
      }, {
        key: "featureFlagsToArray",
        value: function (e) {
          return e ? Object.entries(e).map(function (e) {
            var t,
              n,
              r = (n = 2, function (e) {
                if (Array.isArray(e)) return e;
              }(t = e) || function (e, t) {
                var n = null == e ? null : "undefined" != typeof Symbol && e[Symbol.iterator] || e["@@iterator"];
                if (null != n) {
                  var r,
                    o,
                    i,
                    a,
                    l = [],
                    u = !0,
                    c = !1;
                  try {
                    if (i = (n = n.call(e)).next, 0 === t) {
                      if (Object(n) !== n) return;
                      u = !1;
                    } else for (; !(u = (r = i.call(n)).done) && (l.push(r.value), l.length !== t); u = !0);
                  } catch (e) {
                    c = !0, o = e;
                  } finally {
                    try {
                      if (!u && null != n.return && (a = n.return(), Object(a) !== a)) return;
                    } finally {
                      if (c) throw o;
                    }
                  }
                  return l;
                }
              }(t, n) || function (e, t) {
                if (e) {
                  if ("string" == typeof e) return l(e, t);
                  var n = Object.prototype.toString.call(e).slice(8, -1);
                  return "Object" === n && e.constructor && (n = e.constructor.name), "Map" === n || "Set" === n ? Array.from(e) : "Arguments" === n || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n) ? l(e, t) : void 0;
                }
              }(t, n) || function () {
                throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
              }());
            return {
              featureKey: r[0],
              isActive: r[1]
            };
          }) : [];
        }
      }]) && u(t.prototype, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }();
    function f(e) {
      return f = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (e) {
        return typeof e;
      } : function (e) {
        return e && "function" == typeof Symbol && e.constructor === Symbol && e !== Symbol.prototype ? "symbol" : typeof e;
      }, f(e);
    }
    function p(e, t) {
      var n = Object.keys(e);
      if (Object.getOwnPropertySymbols) {
        var r = Object.getOwnPropertySymbols(e);
        t && (r = r.filter(function (t) {
          return Object.getOwnPropertyDescriptor(e, t).enumerable;
        })), n.push.apply(n, r);
      }
      return n;
    }
    function b(e) {
      for (var t = 1; t < arguments.length; t++) {
        var n = null != arguments[t] ? arguments[t] : {};
        t % 2 ? p(Object(n), !0).forEach(function (t) {
          s(e, t, n[t]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(n)) : p(Object(n)).forEach(function (t) {
          Object.defineProperty(e, t, Object.getOwnPropertyDescriptor(n, t));
        });
      }
      return e;
    }
    function s(e, t, n) {
      return (t = m(t)) in e ? Object.defineProperty(e, t, {
        value: n,
        enumerable: !0,
        configurable: !0,
        writable: !0
      }) : e[t] = n, e;
    }
    function y(e, t) {
      for (var n = 0; n < t.length; n++) {
        var r = t[n];
        r.enumerable = r.enumerable || !1, r.configurable = !0, "value" in r && (r.writable = !0), Object.defineProperty(e, m(r.key), r);
      }
    }
    function m(e) {
      var t = function (e, t) {
        if ("object" !== f(e) || null === e) return e;
        var n = e[Symbol.toPrimitive];
        if (void 0 !== n) {
          var r = n.call(e, t);
          if ("object" !== f(r)) return r;
          throw new TypeError("@@toPrimitive must return a primitive value.");
        }
        return String(e);
      }(e, "string");
      return "symbol" === f(t) ? t : String(t);
    }
    var d = function () {
      function e(t) {
        var n = t.language,
          r = t.endpointUrl,
          o = t.mobileBreakpoint,
          a = t.platform,
          l = t.context;
        !function (e, t) {
          if (!(e instanceof t)) throw new TypeError("Cannot call a class as a function");
        }(this, e), this.clientState = new i({
          language: n,
          mobileBreakpoint: o,
          platform: a,
          context: l
        }), this.reporter = new c(r || "/en/api/v1/telemetry");
      }
      var t, n;
      return t = e, n = [{
        key: "setFeatureFlags",
        value: function (e) {
          return this.clientState.featureFlags = e, this;
        }
      }, {
        key: "pageView",
        value: function () {
          var e = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {},
            t = e.pageId,
            n = e.context;
          return this.sendEvent("page_view", {
            pageId: t,
            context: n
          });
        }
      }, {
        key: "elementClick",
        value: function (e) {
          var t = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            n = t.context,
            r = t.buttonId,
            o = t.pageId;
          return this.sendEvent("button_click", {
            buttonLabel: e,
            buttonId: r,
            context: n,
            pageId: o
          });
        }
      }, {
        key: "sendEvent",
        value: function (e) {
          var t = this,
            n = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {},
            r = n.buttonLabel,
            o = n.buttonId,
            i = n.pageId,
            a = n.context;
          return new Promise(function (n) {
            var l = t.clientState.getStaticProbe();
            t.reporter.sendProbe(b(b({}, l), {}, {
              event: e,
              buttonLabel: r,
              buttonId: o,
              pageId: i,
              context: b(b({}, l.context), a)
            })).finally(function () {
              return n(t);
            });
          });
        }
      }], n && y(t.prototype, n), Object.defineProperty(t, "prototype", {
        writable: !1
      }), e;
    }();
    return t;
  })();
});